import { _ as r } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { c as s, e as o, g as t } from "./define-element-XpjsV6s1.js";
const a = { role: "status" }, i = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  "enable-background": "new 0 0 0 0",
  "xml:space": "preserve",
  class: "offset-loader",
  "aria-hidden": "true"
}, l = ["cx"], n = 10, p = {
  __name: "Loader",
  setup(d) {
    return (u, e) => (s(), o("span", a, [
      (s(), o("svg", i, [
        t("circle", {
          stroke: "none",
          cx: n,
          cy: "50",
          r: n
        }, e[0] || (e[0] = [
          t("animate", {
            attributeName: "opacity",
            dur: "1s",
            values: "0;1;0",
            repeatCount: "indefinite",
            begin: "0.1"
          }, null, -1)
        ])),
        t("circle", {
          stroke: "none",
          cx: "50",
          cy: "50",
          r: n
        }, e[1] || (e[1] = [
          t("animate", {
            attributeName: "opacity",
            dur: "1s",
            values: "0;1;0",
            repeatCount: "indefinite",
            begin: "0.2"
          }, null, -1)
        ])),
        t("circle", {
          stroke: "none",
          cx: 100 - n,
          cy: "50",
          r: n
        }, e[2] || (e[2] = [
          t("animate", {
            attributeName: "opacity",
            dur: "1s",
            values: "0;1;0",
            repeatCount: "indefinite",
            begin: "0.3"
          }, null, -1)
        ]), 8, l)
      ])),
      e[3] || (e[3] = t("span", { class: "offset-loader-sr-text" }, "Loading…", -1))
    ]));
  }
}, m = /* @__PURE__ */ r(p, [["__scopeId", "data-v-995785d9"]]);
export {
  m as L
};
